import { useEffect } from 'react';

import { useAppSelector, useAppDispatch } from 'store/store-hooks';

import { Modal } from 'components/UI/modal/modal';
import { AuthResetPass } from './components/auth-reset-pass';
import { ModalEnum, setModal } from 'components/app/_mediator/app.slice';
import { sendOtp } from './auth.slice';

export const AuthAppResetPass = () => {
  const modal = useAppSelector((state) => state.app.modal);
  const user = useAppSelector((state) => state.app__data.user);
  const isActive = modal === ModalEnum.resetPass;
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!isActive || !user) return;
    dispatch(sendOtp({ email: user.email }));
  }, [isActive]);

  return (
    <Modal onRequestClose={() => dispatch(setModal(0))} isOpen={isActive}>
      <AuthResetPass />
    </Modal>
  );
};
